document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('accordionFilter');
    if (!container) {
        return;
    }

    container.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.matches('input[data-single-select-group]')) {
            return;
        }
        var groupName = target.getAttribute('data-single-select-group');
        if (!groupName) {
            return;
        }
        var checkboxes = document.querySelectorAll('input[name="' + groupName + '"]');
        checkboxes.forEach(function (checkbox) {
            if (checkbox !== target) {
                checkbox.checked = false;
            }
        });
    });
});
